module.exports = __webpack_public_path__ + "img/icon_日.16fd0e4e.svg";